import React, { useState, useEffect } from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom"; // Importe useLocation
import logmann from "../assets/logmann.png";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const location = useLocation(); // Obtenha a localização atual

  const toggleNav = () => {
    setNav(!nav);
  };

  // Função para rolar suavemente até uma seção
  const handleScroll = (target) => {
    const targetElement = document.getElementById(target);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }

    setNav(false); // Fecha o menu mobile após o clique
  };

  useEffect(() => {
    const closeNavOnScroll = () => {
      if (nav) {
        setNav(false);
      }
    };

    window.addEventListener("scroll", closeNavOnScroll);

    return () => {
      window.removeEventListener("scroll", closeNavOnScroll);
    };
  }, [nav]);

  // Itens do Navbar
  const navItems = [
    { id: 1, text: "Início", target: "/", type: "link" }, // Rota para a página inicial
    { id: 2, text: "Contato", target: "Contato", type: "scroll" }, // Scroll para a seção "Contato"
    { id: 3, text: "Demandas", target: "Demandas", type: "scroll" }, // Scroll para a seção "Demandas"
  ];

  // Filtra os itens do Navbar com base na rota atual
  const filteredNavItems =
    location.pathname === "/pedras" ||
    location.pathname === "/caminho" ||
    location.pathname === "/ansiedade" ||
    location.pathname === "/frustracao" ||
    location.pathname === "/procrastinacao" ||
    location.pathname === "/futuro" ||
    location.pathname === "/tempo" ||
    location.pathname === "/amar"
      ? navItems.filter((item) => item.target === "/") // Mostra apenas "Início" nas páginas "Pedras" e "Caminho"
      : navItems; // Mostra todos os itens em outras páginas

  return (
    <section id="Home">
      <div className="bg-[#ad6a51] flex justify-between items-center h-20 px-4 font-semibold text-[#EFD770] relative shadow-xl w-full">
        {/* Logo */}
        <div className="flex items-center mt-8">
          <img
            src={logmann}
            alt="Logo-header"
            className="w-52 h-52 object-contain"
          />
        </div>

        {/* Menu mobile */}
        <ul
          className={
            nav
              ? "flex flex-col justify-center items-center fixed top-0 left-0 w-full h-screen bg-gradient-to-b from-[#ad6a51] to-[#d4b3a7] text-[#EFD770] font-semibold ease-in-out duration-500"
              : "hidden"
          }
        >
          {filteredNavItems.map((item) => (
            <li
              key={item.id}
              className="duration-300 cursor-pointer border-gray-600 my-2 md:my-0"
            >
              {item.type === "link" ? (
                <Link
                  to={item.target} // Use o Link para navegar entre rotas
                  className={`p-2 hover:text-[#00df9a] ${
                    nav ? "text-4xl " : "text-base"
                  }`}
                  onClick={toggleNav} // Fecha o menu ao clicar em um link
                >
                  {item.text}
                </Link>
              ) : (
                <span
                  className={`p-2 hover:text-[#00df9a] ${
                    nav ? "text-4xl " : "text-base"
                  }`}
                  onClick={() => handleScroll(item.target)} // Scroll para a seção
                >
                  {item.text}
                </span>
              )}
            </li>
          ))}
        </ul>

        {/* Botão de abrir/fechar menu mobile */}
        <div
          onClick={toggleNav}
          className="cursor-pointer pr-4 z-10 text-[#EFD770] md:hidden"
        >
          {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
        </div>

        {/* Menu desktop */}
        <ul className="hidden md:flex w-full justify-end">
          {filteredNavItems.map((item) => (
            <li
              key={item.id}
              className="p-2 rounded m-1 cursor-pointer duration-300 text-xl"
            >
              {item.type === "link" ? (
                <Link
                  to={item.target} // Use o Link para navegar entre rotas
                  className="hover:text-[#a3e37d]"
                >
                  {item.text}
                </Link>
              ) : (
                <span
                  className="hover:text-[#a3e37d]"
                  onClick={() => handleScroll(item.target)} // Scroll para a seção
                >
                  {item.text}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Navbar;
